import { PRODUCTS } from 'common/constants'
import { FilterType } from 'common-ui/components/Filter'
import type { FieldFilterConfig } from './Table'

export type CustomerFieldFilters = { name: string }
export const customerFieldFilters: FieldFilterConfig<CustomerFieldFilters>[] = [
    { type: FilterType.text, filterName: 'name', label: 'Name', operator: 'is' },
]

export type InstallationFieldFilters = { host: string; releaseTag: string; deploymentProvider: string }
export const installationFieldFilters: FieldFilterConfig<InstallationFieldFilters>[] = [
    { type: FilterType.text, filterName: 'host', label: 'Host', operator: 'is' },
    { type: FilterType.text, filterName: 'releaseTag', label: 'Release', operator: 'is' },
    { type: FilterType.text, filterName: 'deploymentProvider', label: 'Deployment provider', operator: 'is' },
]

export type LicenseFieldFilters = { customerName: string; productId: string }
export const licenseFieldFilters: FieldFilterConfig<LicenseFieldFilters>[] = [
    { type: FilterType.text, filterName: 'customerName', label: 'Customer name' },
    {
        type: FilterType.select,
        filterName: 'productId',
        label: 'Product',
        options: Object.values(PRODUCTS).map(({ id, name }) => ({ value: id, name })),
    },
]

export type ApplianceFieldFilters = { serialNumber: string }
export const applianceFieldFilters: FieldFilterConfig<ApplianceFieldFilters>[] = [
    { type: FilterType.text, filterName: 'serialNumber', label: 'Serial number', operator: 'is' },
]
